<kin-form-autocomplete
      (input)="handleInput($event)"
      (onFocus)="handleFocus($event)"
      [fieldData]="fieldData"
      [form]="form"
      [readonly]="readonly"
      [allowCustom]="true"
></kin-form-autocomplete>
